import { memo, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../APIs/ForeignData.api";
import { components } from "react-select";
import { useEffect } from "react";

const Component = ({
  label,
  table_id,
  primary_key,
  onChange,
  field,
  search_type,
  isMulti = false,
}) => {
  const [data, setData] = useState({
    options: [],
    hasMore: false,
    additional: {
      page: 0,
    },
  });
  const [selectedValue, setSelectedValue] = useState();
  const { lang, proxy, auth, pages, functions } = useSelector((state) => state);
  const { normalizeStringAccent } = functions;
  const _token = localStorage.getItem("_token");

  const filterData = (data, search) => {
    search = normalizeStringAccent(String(search));

    const filteredOptions = data.options.filter((item) => {
      item.label = normalizeStringAccent(String(item.label));
      return item.label.toLowerCase().includes(search.toLowerCase());
    });

    return {
      ...data,
      options: filteredOptions,
    };
  };
  const handleGetData = async (page = 0, search = "") => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await ForeignData_API.get(proxy(), _token, {
          table_id,
          start_index: page,
          criteria: { [field.fomular_alias]: search },
          criteria_type: { [field.fomular_alias]: search_type?.value },
        });

        const alias = res.fields.find(
          (field) => field.id === primary_key
        )?.fomular_alias;

        let newData = {
          options: [],
          hasMore: false,
          additional: {
            page: 0,
          },
        };
        if (res.data.length) {
          const newOptions = res.data.map((item) => ({
            label: item[alias],
            value: item[alias],
          }));

          const combinedOptions = [...(data?.options || []), ...newOptions];

          const uniqueMap = new Map();
          combinedOptions.forEach((opt) => {
            const key = String(opt.value).trim().toLowerCase();
            if (!uniqueMap.has(key)) {
              uniqueMap.set(key, opt);
            }
          });

          const options = Array.from(uniqueMap.values());

          newData = {
            options,
            hasMore: res.data.length > 0,
            additional: {
              page: options.length > 0 ? page + 100 : page,
            },
          };

          // const optionsRaw = res.data.map((item) => ({
          //   label: item[alias],
          //   value: item[alias],
          // }));

          // const uniqueMap = new Map();
          // optionsRaw.forEach((opt) => {
          //   const normalizedLabel = String(opt.label).trim().toLowerCase();
          //   if (!uniqueMap.has(normalizedLabel)) {
          //     uniqueMap.set(normalizedLabel, opt);
          //   }
          // });

          // const options = Array.from(uniqueMap.values());

          // newData = {
          //   options,
          //   hasMore: options.length > 0,
          //   additional: {
          //     page: options.length > 0 ? page + 15 : page,
          //   },
          // };
          // setData((prev) => {
          //   newData = {
          //     additional: { page: page + 15 },
          //     hasMore: res.data.length ? true : false,
          //     options: res.data.map((item) => ({
          //       label: item[alias],
          //       value: item[alias],
          //     })),
          //   };
          //   return {
          //     additional: { page: page + 15 },
          //     hasMore: res.data.length ? true : false,
          //     options: [
          //       ...prev.options,
          //       ...res.data.map((item) => ({
          //         label: item[alias],
          //         value: item[alias],
          //       })),
          //     ],
          //   };
          // });
        }
        setTimeout(() => {
          resolve(filterData(newData, search));
        }, 100);
      } catch (err) {
        console.log("OPTION ERROR:", err);
      }
    });
  };
  useEffect(() => {
    setSelectedValue(null);
  }, [field]);
  const handleOnchange = (props) => {
    setSelectedValue(props);
    onChange(props);
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "5px",
      border: "2px solid #ccc",
      boxShadow: state.isFocused ? "0 0 0 2px #3699FF" : null,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#3699FF" : null,
      color: state.isFocused ? "white" : null,
    }),
  };
  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  return (
    <>
      <AsyncPaginate
        placeholder={lang["select value"]}
        components={{
          Option: CustomOption,
        }}
        loadOptions={async (search, loadedOptions, { page }) => {
          return await handleGetData(page, search);
        }}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        onChange={(options) => {
          if (!isMulti) {
            const { value, label } = options;
            if (options.value === "unSelect") {
              handleOnchange([{ label: "", value: "" }]);
            } else {
              handleOnchange([{ label, value }]);
            }
            return;
          }
          handleOnchange(options);
        }}
        isMulti
        options={
          !isMulti
            ? [
                {
                  value: "unSelect",
                  label: lang["default value"],
                },
              ]
            : []
        }
        isSearchable={true}
        styles={{
          menuList: (base) => ({
            ...base,
            maxHeight: "300px",
            // color: "#58718a !important"
            fontFamily: "UTM Avo , sans-serif !important",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          valueContainer: (base) => ({
            ...base,
            maxHeight: "100px",
            overflow: "auto",
          }),
        }}
        value={selectedValue}
        additional={{
          page: 0,
        }}
        allowCreateWhileLoading={false} // Không cho phép tạo mới khi đang tải dữ liệu
      />
    </>
  );
};
export const Option = memo(Component);
